import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const TRUST_SEALS = 'https://cdn.magicpatterns.com/uploads/w3P4deQD4AoHx5GEDfKUk1/capture_260410_163646.png';
const PRODUCT_PACK = 'https://cdn.magicpatterns.com/uploads/1fsjP3pXteAL7ez6U4DSHk/Necesito_que_me_202603212200.png';
const CHECKOUT_URL = 'https://checkout.bobaprofessional.shop/cart/45644497617094:1';
export function FinalCheckoutSection() {
  return <section className="py-16 bg-white" data-id="element-162">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-163">
        {/* Product Pack Image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8" data-id="element-164">
          <img src={PRODUCT_PACK} alt="Boba Professional Pack" width={800} height={800} loading="lazy" decoding="async" className="w-full max-w-lg mx-auto drop-shadow-2xl" data-id="element-165" />
        </motion.div>

        {/* Pricing Info */}
        <div className="mb-8" data-id="element-166">
          <p className="line-through text-2xl text-red-500 font-bold mb-2 uppercase" data-id="element-167">
            ANTES: $59.900 ARS
          </p>
          <div className="flex flex-col items-center gap-2" data-id="element-168">
            <span className="font-extrabold text-4xl uppercase text-gray-800" data-id="element-169">
              HOY:
            </span>
            <div className="px-8 py-4 bg-[#19A806] rounded-2xl shadow-lg inline-flex items-baseline gap-2" data-id="element-170">
              <span className="text-4xl md:text-6xl text-white font-black" data-id="element-171">
                $19.990
              </span>
              <span className="text-white font-bold text-xl" data-id="element-172">ARS</span>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <motion.a href={CHECKOUT_URL} rel="noopener noreferrer" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="inline-flex w-full max-w-md bg-[#FFD700] hover:bg-[#FFE033] text-black text-xl font-black py-6 px-8 rounded-2xl shadow-xl transition-all uppercase tracking-tight mb-8" data-id="element-173">
          CLIC AQUÍ PARA OBTENER LA OFERTA →
        </motion.a>

        {/* Trust Seals Image */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-4" data-id="element-174">
          <img src={TRUST_SEALS} alt="Pago seguro garantizado" width={600} height={200} loading="lazy" decoding="async" className="w-full max-w-md mx-auto" data-id="element-175" />
        </motion.div>
      </div>
    </section>;
}